<template>
  <div class="container">
    <div class="delete-user-complete"
         :class="{'padding-webview' : checkWebview()}">
      <h3 class="title">退会完了</h3>

      <div class="delete-user-complete__container step">

        <div class="step__register">

          <div class="step__block">
            <h4>退会処理が完了いたしました。</h4>

            <a class="btn__register" @click.prevent="openPageNative('Index')">
              トップページへ
              <ChevronRightIcon size="24"/>
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// Icon
import { ChevronRightIcon } from 'vue-feather-icons'
import Common from '@/mixins/common.mixin'
export default {
  name: 'DeleteUserComplete',

  mixins: [Common],

  components: {
    ChevronRightIcon
  },

  mounted () {
    // hide app's loading after page render
    if (Common.methods.checkWebview()) {
      Common.methods.triggerEventApp('PAGE_RENDERED', {})
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-user-complete {
  padding: 90px 0;
  @media #{$info-phone} {
    padding: 85px 0;
  }
  &.padding-webview {
    padding: 40px 0;
  }
  .title {
    font-family: $font-family-title;
    color: $default-green;
    @include font-size(36px);
    font-weight: 400;
    text-align: center;
    margin-bottom: 40px;
    @media #{$info-phone} {
      font-size: 32px;
      margin-bottom: 30px;
    }
  }

  &__container {
    border: 6px solid #E7E5DE;
    border-radius: 6px;
    background-color: #FAFAFA;
    @media #{$info-phone} {
      border: 3px solid #E7E5DE;
      border-left: none;
      border-right: none;
      border-radius: 0;
    }
  }

  .step {
    &__block {
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      padding: 55px;
      @media #{$info-phone} {
        padding: 18px;
      }
    }

    .btn__register {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 360px;
      width: 100%;
      border-radius: 6px;
      color: #ffffff;
      background: #6F8784;
      font-family: $font-family-title;
      @include font-size(18px);
      padding: 14px;
      margin: auto;
      cursor: pointer;

      @media #{$info-phone} {
        font-size: 16px;
        padding: 10px;
        max-width: 100%;
      }

      svg {
        margin-left: 5px;
      }
    }

    h4 {
      text-align: center;
      font-weight: 500;
      color: $default-green;
      @include font-size(24px);
      margin-bottom: 30px;
      @media #{$info-phone} {
        font-size: 20px;
        margin-bottom: 20px;
      }
    }
  }
}

@media #{$info-phone} {
  .container {
    padding: 0;
  }
}
</style>
